export const hasMagicResizePerm = (user) => {
    try {
        return true;
        // return (user.type === 'admin' || user['inmagineUser']['userDetails']['user']['subscription']['sub_status'] === true)
    } catch (e) {
        return false;
    }
};


export const hasWizardPerm = (user) => {
    try {
        return true;
        // return (user.type === 'admin' || user['inmagineUser']['userDetails']['user']['subscription']['sub_status'] === true)
    } catch (e) {
        return false;
    }
};


export const hasAutoSuggestPerm = (user) => {
    try {
        return true;
        // return (user.type === 'admin' || user['inmagineUser']['userDetails']['user']['subscription']['sub_status'] === true)
    } catch (e) {
        return false;
    }
};

export const hasMockupPerm = (user) => {
    try {
        return (user.type === 'admin' || (user['inmagineUser']['userDetails']['user']['subscription']['sub_status'] === true && user['inmagineUser']['userDetails']['user']['subscription']['scope'].includes("designmaker")))
    } catch (e) {
        return false;
    }
};
